import {AfterViewInit, Component, Input} from '@angular/core';
import {BestPerformingExposure} from '../../../../../models/influencer';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';

@Component({
  selector: 'best-performing-exposure',
  templateUrl: './best-performing-exposure.component.html',
  styleUrls: ['./best-performing-exposure.component.scss']
})
export class BestPerformingExposureComponent implements AfterViewInit {
  static COMPONENT_NAME = 'BestPerformingExposureComponent';
  @Input() bestPerformingExposures: BestPerformingExposure[] = [];
  @Input() showIndexNumber = false;
  @Input() forPayingUser = false;

  constructor(private pdfService: PdfExportService,
              private userService: UserService) {

  }

  ngAfterViewInit() {
    if (this.bestPerformingExposures.length === 0) {
      this.pdfService.incrementNumberReportReady(BestPerformingExposureComponent.COMPONENT_NAME);
    }
    this.pdfService.imagedLoadedTrigger.subscribe(data => {
      if (data.component === BestPerformingExposureComponent.COMPONENT_NAME
            && data.currentCounter === this.bestPerformingExposures.length) {
        console.log(`bestPerformingExposures image counter: ${data.currentCounter}`);
        this.pdfService.incrementNumberReportReady(BestPerformingExposureComponent.COMPONENT_NAME);
      }
    });
  }

  get showFallbackView() {
    return this.bestPerformingExposures.length === 0
      || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure.component.ts